import React from 'react'
import './Footer.css'
import { FaFacebookF } from 'react-icons/fa';
import { FaLinkedinIn } from 'react-icons/fa';
import { BsInstagram } from 'react-icons/bs';



const Footer = () => {
  return (
    <footer>
      <a href="#" className='footer__logo'>RIDOY</a>


      <ul className='permalinks'>
        <li><a href="#">Home</a></li>
        <li><a href="#about">About</a></li>
        <li><a href="#experience">Experience</a></li>
        <li><a href="#services">Services</a></li>
        <li><a href="#portfolio">Projects</a></li>
        <li><a href="#contact">Contact</a></li>
      </ul>


      <div className="footer__social">
        <a href="https://www.facebook.com/mdalmamun.ridoy"><FaFacebookF /></a>
        <a href="https://www.linkedin.com/in/almamunridoy/"><FaLinkedinIn /></a>
        <a href="https://www.instagram.com/accounts/login/?next=/a.m.ridoy4/"><BsInstagram /></a>
      </div>



      <div className="footer__copyright">
        <small>&copy; RIDOY Portfolio. All rights reserved.</small>
      </div>
    </footer>
  )
}

export default Footer